import { deepEquals } from '@util/copy'
import goBackWithFallback from '@util/goBackWithFallback'

const directive = {
  bind: function (el: HTMLElement, binding, vnode) {
    if (!el.id) {
      el.id = `go-back-directive-${getRandomInt(999999).toString()}`
    }
    createAndSetListener(el, binding, vnode)
  },

  update: function (el: HTMLElement, binding, vnode) {
    if (!deepEquals(binding.value, binding.oldValue)) {
      el.removeEventListener('click', lastFunctions[el.id])
      createAndSetListener(el, binding, vnode)
    }
  },

  unbind: function (el: HTMLElement, binding, vnode) {
    el.removeEventListener('click', lastFunctions[el.id])
    delete lastFunctions[el.id]
    el.removeAttribute('id')
  }
}

let lastFunctions = {}

function createAndSetListener (el, binding, vnode) {
  const handler = listener(binding, vnode)
  lastFunctions[el.id] = handler
  el.addEventListener('click', handler)
}

function getRandomInt (max) {
  return Math.floor(Math.random() * max)
}

function listener (binding, vnode) {
  return () => {
    if (binding.value) {
      goBackWithFallback(
        vnode.context.$router,
        !!vnode.context.$store.state.Router.from.name,
        binding.value,
        binding.modifiers.usePush, // e.g. v-goBack.usePush.useLocation="[Location]"
        binding.modifiers.useLocation
      )
    }
  }
}

export default directive

